module.exports = __webpack_public_path__ + "img/couponIcon.05faedca.svg";